// import React, { useEffect, useRef, useState } from "react";
// import {
//   Card,
//   CardBody,
//   Modal,
//   ModalBody,
//   ModalHeader,
//   Table,
// } from "reactstrap";
// import numberToWords from "../../../../../Components/Common/numberToWords";
// import { PrintBill } from "../../../BillPrint/page/PrintBill";
// import CostCenterService from "../../../../../services/OrderingServices/CostCenterService";
// import {
//   convertADtoBS,
//   formatDateTime,
//   formatDatev2,
// } from "../../../../../CosmosAdminPages/Appointment/Component/FormatDate";
// import html2pdf from "html2pdf.js";

// const InvoiceBillModal = ({
//   isOpen,
//   toggle,
//   orgInfo,
//   user,
//   selectedTable,
//   orderId,
//   billData,
//   calculateTotals,
//   responseData,
//   selectedCustomer,
//   selectedPayments,
//   userInfo,
//   // placedItems,
// }) => {
//   console.log("🚀 ~ InvoiceBillModal ~ userInfo:", userInfo);
//   console.log("🚀 ~ InvoiceBillModal ~ selectedPayments:", selectedPayments);
//   console.log("🚀 ~ InvoiceBillModal ~ selectedCustomer:", selectedCustomer);
//   console.log("🚀 ~ InvoiceBillModal ~ responseData:", responseData);
//   const [expandedItems, setExpandedItems] = useState({});
//   const toggleChildren = (itemKey) => {
//     setExpandedItems((prev) => ({
//       ...prev,
//       [itemKey]: !prev[itemKey],
//     }));
//   };

//   const rawOrder = billData?.[selectedTable?.id];
//   const billRef = useRef();

//   // NEW: Payment Modal state
//   const [paymentModalOpen, setPaymentModalOpen] = useState(false);
//   const [activePayment, setActivePayment] = useState(null);
//   console.log("🚀 ~ InvoiceBillModal ~ activePayment:", activePayment);

//   // const itemsToShow =
//   //   placedItems && placedItems.length > 0 ? placedItems : rawOrder.items || [];
//   // console.log("🚀 ~ InvoiceBillModal ~ itemsToShow:", itemsToShow)
//   const handleDownload = () => {
//     const element = billRef.current;
//     html2pdf()
//       .set({
//         margin: 0.5,
//         filename: `Invoice-${responseData?.invoiceNumber || "Bill"}.pdf`,
//         image: { type: "jpeg", quality: 0.98 },
//         html2canvas: { scale: 2 },
//         jsPDF: { unit: "in", format: "A4", orientation: "portrait" },
//       })
//       .from(element)
//       .save();
//   };

//   const info = user?.user?.subOrgName;
//   console.log("🚀 ~ InvoiceBillModal ~ info:", info);
//   const phoneNumbers = user?.user?.subOrgPhone;

//   const qrImageBase = "https://api-waitermoduleapp.danfesolution.com";
//   const path = `${qrImageBase}/${activePayment?.imagePath}`;
//   console.log("🚀 ~ InvoiceBillModal ~ path:", path);

//   console.log("🚀 ~ InvoiceBillModal ~ responseData:", responseData);
//                       console.log("🚀 ~ InvoiceBillModal ~ responseData:", responseData)
//   return (
//     <>
//       <Modal isOpen={isOpen} toggle={toggle}>
//         <ModalHeader toggle={toggle}>
//           <h5 className="mb-0 fw-bold">✅ Successful Checkout</h5>
//         </ModalHeader>
//         <ModalBody>
//           {/* Title and Actions */}
//           <div className="d-flex justify-content-end gap-2 align-items-center mb-3">
//             <button
//               className="btn btn-light btn-sm"
//               title="Download"
//               onClick={handleDownload}
//             >
//               <i className="ri-download-2-line"></i>
//             </button>

//             {/* NEW: Payment QR button */}
//             {selectedPayments?.length > 0 && (
//               <button
//                 className="btn btn-light btn-sm"
//                 title="View Payment QR"
//                 onClick={() => {
//                   setActivePayment(selectedPayments[0]); // show first payment by default
//                   setPaymentModalOpen(true);
//                 }}
//               >
//                 <i className="ri-bank-line"></i>
//               </button>
//             )}

//             <PrintBill
//               currentOrder={rawOrder}
//               orgInfo={orgInfo}
//               user={user}
//               orderId={orderId}
//               calculateTotals={calculateTotals}
//               responseData={responseData}
//               isestimateprint={false}
//               selectedCustomer={selectedCustomer}
//             />
//           </div>

//           <div ref={billRef}>
//             <Card className="shadow-sm border-0 rounded-3">
//               <CardBody
//                 className="d-flex flex-column p-3"
//                 style={{ fontFamily: "monospace", fontSize: "14px" }}
//               >
//                 {/* Header */}
//                 <div className="text-center mb-2">
//                   <h5 className="fw-bold text-uppercase mb-0">
//                     {userInfo?.categoryId === null ? orgInfo?.name : info}
//                   </h5>
//                   <div className="text-uppercase">
//                     {orgInfo?.address1 || ""}
//                   </div>
//                   <div>
//                     {userInfo?.categoryId === null
//                       ? orgInfo?.tel
//                       : phoneNumbers}
//                   </div>
//                   <div className="fw-bold mt-1">INVOICE</div>
//                 </div>

//                 {/* Info Rows */}
//                 <div className="d-flex justify-content-between small mb-1">
//                   <div>
//                     <strong>PAN No.:</strong> {orgInfo?.pan || "..."}
//                   </div>
//                   <div>
//                     <strong>Copy of:</strong> Original
//                   </div>
//                 </div>
//                 <div className="d-flex justify-content-between small mb-1">
//                   <div>
//                     <strong>Customer:</strong>{" "}
//                     {selectedCustomer
//                       ? `${selectedCustomer.firstName} ${selectedCustomer.lastName}`
//                       : "...."}
//                   </div>
//                   <div>
//                     <strong>PAN:</strong> {"..."}
//                   </div>
//                 </div>
//                 <div className="d-flex justify-content-between small mb-1">
//                   <div>
//                     <strong>Phone No.:</strong>{" "}
//                     {selectedCustomer?.phoneNo || "...."}
//                   </div>
//                   <div>
//                     <strong>Cashier:</strong> {"..."}
//                   </div>
//                 </div>
//                 <div className="d-flex justify-content-between small mb-1">
//                   <div>
//                     <strong>Address:</strong>{" "}
//                     {selectedCustomer?.address || "...."}
//                   </div>
//                   <div>
//                     <strong>INV No:</strong>{" "}
//                     {responseData?.invoiceNumber || "..."}
//                   </div>
//                 </div>
//                 <div className="d-flex justify-content-between small mb-2">
//                   {/* <div>
//                 <strong>Date (B.S.):</strong>  {convertADtoBS(responseData?.billDate)}
//               </div> */}
//                   <div>
//                     <strong>Date (A.D.):</strong>{" "}
//                     {formatDatev2(responseData?.billDate)}
//                   </div>
//                 </div>
//                 <div className="d-flex justify-content-between small mb-2">
//                   <div>
//                     <strong>Table ID:</strong>{" "}
//                     {responseData?.orderSummary?.tableId || "T-1"}
//                   </div>
//                   <div>
//                     <strong>Time:</strong>{" "}
//                     {new Date().toLocaleTimeString([], {
//                       hour: "2-digit",
//                       minute: "2-digit",
//                     })}
//                   </div>
//                 </div>

//                 {/* Table */}
//                 <Table
//                   size="sm"
//                   responsive
//                   className="table-bordered small mb-0"
//                 >
//                   <thead>
//                     <tr>
//                       <th>SN</th>
//                       <th>Item</th>
//                       <th className="text-center">Qty</th>
//                       <th className="text-center">Rate</th>
//                       <th className="text-end">Amnt</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {responseData &&
//                       responseData?.orderSummary?.orderDetails?.map(
//                         (item, index) => {
//                           const itemKey = `${item?.tableId}-${index}`;
//                           const isExpanded = expandedItems[itemKey];

//                           return (
//                             <tr key={index}>
//                               <td>{index + 1}</td>

//                               <td className="text-level-2">
//                                 <h6
//                                   className={`fw-semibold  mb-1 ${
//                                     item?.children?.length > 0 ||
//                                     item?.attributes?.length > 0
//                                       ? "text-secondary cursor-pointer"
//                                       : ""
//                                   }`}
//                                   onClick={(e) => {
//                                     e.stopPropagation(); // prevent card click
//                                     toggleChildren(itemKey);
//                                   }}
//                                 >
//                                   {item?.productName}
//                                 </h6>

//                                 {/* Collapsible Children */}
//                                 <div
//                                   className="overflow-hidden"
//                                   style={{
//                                     maxHeight: isExpanded
//                                       ? `${item.children?.length * 50}px`
//                                       : "0px",
//                                     transition: "max-height 0.3s ease",
//                                   }}
//                                 >
//                                   {item?.children?.map((childItem, indx) => (
//                                     <div
//                                       key={childItem.id || indx}
//                                       className="mt-2"
//                                     >
//                                       <div className="d-flex justify-content-between">
//                                         <small>+ {childItem.productName}</small>
//                                         <small>{childItem?.productPrice}</small>
//                                       </div>

//                                       {childItem?.attributes?.map((attr) => (
//                                         <small
//                                           key={attr.id}
//                                           className="text-muted d-block ms-2"
//                                         >
//                                           - {attr.title}
//                                         </small>
//                                       ))}
//                                     </div>
//                                   ))}
//                                 </div>

//                                 {/* Collapsible Attributes */}
//                                 <div
//                                   className="overflow-hidden"
//                                   style={{
//                                     maxHeight: isExpanded
//                                       ? `${item.attributes?.length * 50}px`
//                                       : "0px",
//                                     transition: "max-height 0.3s ease",
//                                   }}
//                                 >
//                                   {item?.attributes?.map((childItem, indx) => (
//                                     <div key={indx} className="mt-2">
//                                       <div className="d-flex justify-content-between">
//                                         <small>+ {childItem.title}</small>
//                                         {/* <small>{childItem?.value}</small> */}
//                                       </div>
//                                     </div>
//                                   ))}
//                                 </div>
//                               </td>

//                               <td className="text-center">
//                                 {item.finalQuantity}
//                               </td>

//                               {item?.attributes?.length > 0 ? (
//                                 <td className="text-end text-level-3">
//                                   {item?.attributes[0]?.value?.toFixed(2)}
//                                 </td>
//                               ) : (
//                                 <td className="text-end text-level-3">
//                                   {item?.productPrice?.toFixed(2)}
//                                 </td>
//                               )}

//                               {item?.attributes?.length > 0 ? (
//                                 <td className="text-end text-level-3">
//                                   {(
//                                     item?.quantity * item?.attributes[0]?.value
//                                   ).toFixed(2)}
//                                 </td>
//                               ) : (
//                                 <td className="text-end text-level-3">
//                                   {(
//                                     item?.quantity * item?.productPrice
//                                   ).toFixed(2)}
//                                 </td>
//                               )}
//                             </tr>
//                           );
//                         }
//                       )}
//                   </tbody>
//                 </Table>

//                 {/* Totals */}
//                 <div className="border-top pt-2 small">
//                   <div className="d-flex justify-content-between">
//                     <div>Total Qty:</div>
//                     <div>
//                       {rawOrder?.items.reduce((a, b) => a + b.quantity, 0)}
//                     </div>
//                   </div>
//                   <div className="d-flex justify-content-between">
//                     <div>Sub Total:</div>
//                     <div>Rs. {responseData?.totalAmount.toFixed(2)}</div>
//                   </div>
//                   <div className="d-flex justify-content-between">
//                     <div>Discount Amount:</div>
//                     <div>Rs. {responseData?.discountAmount.toFixed(2)}</div>
//                   </div>
//                   <div className="d-flex justify-content-between">
//                     <div>Tax Amount:</div>
//                     <div>Rs. {responseData?.taxAmount.toFixed(2)}</div>
//                   </div>
//                   <div className="d-flex justify-content-between fw-bold">
//                     <div>Grand Total Amount:</div>
//                     <div>Rs. {responseData?.grandTotal.toFixed(2)}</div>
//                   </div>
//                   <div className="mt-2">
//                     <div>
//                       <strong>In Words:</strong>{" "}
//                       {numberToWords(responseData?.grandTotal)} Rupees
//                     </div>
//                   </div>
//                 </div>

//                 {/* Footer Info */}
//                 <div className="small mt-2">
//                   <div>Printed On: {new Date().toLocaleString()}</div>
//                   <div className="text-center mt-2">**Thank You**</div>
//                   <div className="text-center text-muted small">
//                     Powered by Restro Order
//                   </div>
//                 </div>
//               </CardBody>
//             </Card>
//           </div>
//         </ModalBody>
//       </Modal>

//       {/* NEW: Payment Modal */}
//       <Modal
//         isOpen={paymentModalOpen}
//         toggle={() => setPaymentModalOpen(false)}
//         centered
//         size="md"
//       >
//         <ModalHeader toggle={() => setPaymentModalOpen(false)}>
//           Payment Details
//         </ModalHeader>
//         <ModalBody className="text-center">
//           {activePayment && (
//             <>
//               <img
//                 src={`${qrImageBase}/${activePayment?.imagePath}`}
//                 alt={activePayment.name}
//                 className="img-fluid object-fit-contain"
//               />
//               {/* <div className="mt-3 text-start">
//                 <div>
//                   <strong></strong> {activePayment.name}
//                 </div>
//                 <div>
//                   <strong></strong> {activePayment.description}
//                 </div>
//                 <div>
//                   <strong></strong> {activePayment.accountNumber}
//                 </div>
//               </div> */}
//             </>
//           )}
//         </ModalBody>
//       </Modal>
//     </>
//   );
// };

// export default InvoiceBillModal;

import React, { useEffect, useRef, useState } from "react";
import {
  Card,
  CardBody,
  Modal,
  ModalBody,
  ModalHeader,
  Table,
} from "reactstrap";
import numberToWords from "../../../../../Components/Common/numberToWords";
import { PrintBill } from "../../../BillPrint/page/PrintBill";
import html2pdf from "html2pdf.js";
import {
  convertADtoBS,
  formatDatev2,
} from "../../../../../CosmosAdminPages/Appointment/Component/FormatDate";

const InvoiceBillModal = ({
  isOpen,
  toggle,
  orgInfo,
  user,
  selectedTable,
  orderId,
  billData,
  calculateTotals,
  responseData,
  selectedCustomer,
  selectedPayments,
  userInfo,
}) => {
  const [expandedItems, setExpandedItems] = useState({});
  const [paymentModalOpen, setPaymentModalOpen] = useState(false);
  const [activePayment, setActivePayment] = useState(null);
  const billRef = useRef();

  const toggleChildren = (itemKey) => {
    setExpandedItems((prev) => ({
      ...prev,
      [itemKey]: !prev[itemKey],
    }));
  };

  const handleDownload = () => {
    const element = billRef.current;
    html2pdf()
      .set({
        margin: 0.5,
        filename: `Invoice-${responseData?.invoiceNumber || "Bill"}.pdf`,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "A4", orientation: "portrait" },
      })
      .from(element)
      .save();
  };

  const info = user?.user?.subOrgName;
  const phoneNumbers = user?.user?.subOrgPhone;
  const qrImageBase = "https://api-waitermoduleapp.danfesolution.com";

  // Calculate totals
  const totalQty =
    responseData?.orderDetails?.reduce(
      (sum, item) => sum + (item.finalQuantity || 0),
      0,
    ) || 0;

  console.log(
    "🚀 ~ InvoiceBillModal ~ responseData?.orderDate:",
    responseData?.orderDate,
  );
  return (
    <>
      <Modal isOpen={isOpen} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          <h5 className="mb-0 fw-bold">✅ Successful Checkout</h5>
        </ModalHeader>

        <ModalBody>
          {/* Header Buttons */}
          <div className="d-flex justify-content-end gap-2 align-items-center mb-3">
            <button
              className="btn btn-light btn-sm"
              title="Download"
              onClick={handleDownload}
            >
              <i className="ri-download-2-line"></i>
            </button>

            {selectedPayments?.length > 0 && (
              <button
                className="btn btn-light btn-sm"
                title="View Payment QR"
                onClick={() => {
                  setActivePayment(selectedPayments[0]);
                  setPaymentModalOpen(true);
                }}
              >
                <i className="ri-bank-line"></i>
              </button>
            )}

            <PrintBill
              currentOrder={responseData}
              orgInfo={orgInfo}
              user={user}
              orderId={orderId}
              calculateTotals={calculateTotals}
              responseData={responseData}
              isestimateprint={false}
              selectedCustomer={selectedCustomer}
              selectedPayments={selectedPayments}
            />
          </div>

          {/* Printable Bill */}
          <div ref={billRef}>
            <Card className="shadow-sm border-0 rounded-3">
              <CardBody
                className="d-flex flex-column p-3"
                style={{ fontFamily: "monospace", fontSize: "14px" }}
              >
                {/* ===== Header Info ===== */}
                <div className="text-center mb-2">
                  <h5 className="fw-bold text-uppercase mb-0">
                    {userInfo?.categoryId === null ? orgInfo?.name : info}
                  </h5>
                  <div className="text-uppercase">
                    {orgInfo?.address1 || ""}
                  </div>
                  <div>
                    {userInfo?.categoryId === null
                      ? orgInfo?.tel
                      : phoneNumbers}
                  </div>
                  <div className="fw-bold mt-1">INVOICE</div>
                </div>

                {/* ===== Customer Info ===== */}
                <div className="d-flex justify-content-between small mb-1">
                  <div>
                    <strong>PAN No.:</strong> {orgInfo?.pan || "..."}
                  </div>
                  <div>
                    <strong>Copy of:</strong> Original
                  </div>
                </div>
                <div className="d-flex justify-content-between small mb-1">
                  <div>
                    <strong>Customer:</strong>{" "}
                    {selectedCustomer
                      ? `${selectedCustomer.firstName} ${selectedCustomer.lastName}`
                      : "...."}
                  </div>
                  <div>
                    <strong>Phone:</strong>{" "}
                    {selectedCustomer?.phoneNo || "...."}
                  </div>
                </div>
                <div className="d-flex justify-content-between small mb-1">
                  <div>
                    <strong>Address:</strong>{" "}
                    {selectedCustomer?.address || "...."}
                  </div>
                  <div>
                    <strong>INV No:</strong>{" "}
                    {responseData?.invoiceNumber || "..."}
                  </div>
                </div>
                <div className="d-flex justify-content-between small mb-2">
                  {/* <div>
                    <strong>Date (A.D.):</strong>{" "}
                    {formatDatev2(responseData?.orderDate)}
                  </div> */}
                  <div>
                    <strong>Table Name:</strong>{" "}
                    {responseData?.tableName || selectedTable?.id || "N/A"}
                  </div>
                </div>

                {/* ===== Items Table ===== */}
                <Table
                  size="sm"
                  responsive
                  className="table-bordered small mb-0"
                >
                  <thead>
                    <tr>
                      <th>SN</th>
                      <th>Item</th>
                      <th className="text-center">Qty</th>
                      <th className="text-center">Rate</th>
                      <th className="text-end">Amnt</th>
                    </tr>
                  </thead>
                  <tbody>
                    {responseData?.orderDetails?.map((item, index) => {
                      const itemKey = `${item?.id}-${index}`;
                      const isExpanded = expandedItems[itemKey];

                      // Base price
                      const basePrice =
                        item?.attributes?.length > 0
                          ? item?.attributes[0]?.value
                          : item?.productPrice;

                      // Add children price
                      const childrenTotal =
                        item?.children?.reduce(
                          (sum, c) =>
                            sum +
                            (c?.productPrice || 0) *
                              (c?.finalQuantity || c?.quantity || 1),
                          0,
                        ) || 0;

                      // Total item price
                      const totalPrice =
                        (item.quantity || 0) * basePrice + childrenTotal;

                      // ----- Complimentary Row -----
                      const ComplimentaryRow =
                        item?.complimentaryQuantity > 0 ? (
                          <tr key={`${index}-comp`}>
                            <td>{index + 1}</td>

                            <td className="text-level-2">
                              <h6 className="fw-semibold mb-1 text-info">
                                {item.productName} (Complimentary)
                              </h6>

                              {/* Expandable attributes and children */}
                              <div
                                className="overflow-hidden"
                                style={{
                                  maxHeight: isExpanded
                                    ? `${item.children?.length * 50}px`
                                    : "0px",
                                  transition: "max-height 0.3s ease",
                                }}
                              >
                                {item?.children?.map((child, i) => (
                                  <div key={i} className="mt-2">
                                    <div className="d-flex justify-content-between">
                                      <small>+ {child.productName}</small>
                                      <small>{child.productPrice}</small>
                                    </div>

                                    {child?.attributes?.map((attr) => (
                                      <small
                                        key={attr.id}
                                        className="text-muted d-block ms-2"
                                      >
                                        - {attr.title}
                                      </small>
                                    ))}
                                  </div>
                                ))}
                              </div>

                              <div
                                className="overflow-hidden"
                                style={{
                                  maxHeight: isExpanded
                                    ? `${item.attributes?.length * 50}px`
                                    : "0px",
                                  transition: "max-height 0.3s ease",
                                }}
                              >
                                {item?.attributes?.map((attr, i) => (
                                  <div key={i} className="mt-2">
                                    <div className="d-flex justify-content-between">
                                      <small>+ {attr.title}</small>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </td>

                            {/* Qty */}
                            <td className="text-center text-primary">
                              {item.complimentaryQuantity}
                            </td>

                            {/* Rate = 0 */}
                            <td className="text-end text-primary">0.00</td>

                            {/* Amount = 0 */}
                            <td className="text-end text-primary">0.00</td>
                          </tr>
                        ) : null;

                      return (
                        <React.Fragment key={index}>
                          <tr>
                            <td>{index + 1}</td>

                            <td>
                              <div
                                className={`fw-semibold ${
                                  (item?.children?.length > 0 ||
                                    item?.attributes?.length > 0) &&
                                  "text-secondary cursor-pointer"
                                }`}
                                onClick={() => toggleChildren(itemKey)}
                              >
                                {item.productName}
                              </div>

                              {/* Children */}
                              <div
                                className="overflow-hidden"
                                style={{
                                  maxHeight: isExpanded
                                    ? `${(item.children?.length || 0) * 40}px`
                                    : "0px",
                                  transition: "max-height 0.3s ease",
                                }}
                              >
                                {item?.children?.map((child, idx) => (
                                  <div
                                    key={idx}
                                    className="d-flex justify-content-between ps-3"
                                  >
                                    <small>+ {child.productName}</small>
                                    <small>{child.productPrice}</small>
                                  </div>
                                ))}
                              </div>

                              {/* Attributes */}
                              <div
                                className="overflow-hidden"
                                style={{
                                  maxHeight: isExpanded
                                    ? `${(item.attributes?.length || 0) * 40}px`
                                    : "0px",
                                  transition: "max-height 0.3s ease",
                                }}
                              >
                                {item?.attributes?.map((attr, idx) => (
                                  <div key={idx} className="ps-3">
                                    <small>• {attr.title}</small>
                                  </div>
                                ))}
                              </div>
                            </td>

                            <td className="text-center">{item.quantity}</td>
                            {/* Rate */}
                            <td className="text-end text-level-3">
                              {(() => {
                                const attrTotal = item?.attributes?.reduce(
                                  (sum, a) => sum + (Number(a.value) || 0),
                                  0,
                                );
                                const childrenTotal = item?.children?.reduce(
                                  (sum, c) =>
                                    sum + (Number(c.productPrice) || 0),
                                  0,
                                );
                                const basePrice =
                                  Number(item?.productPrice) || 0;

                                const unitPrice =
                                  attrTotal || childrenTotal
                                    ? basePrice + attrTotal + childrenTotal
                                    : basePrice;

                                return unitPrice.toFixed(2);
                              })()}
                            </td>

                            {/* Amount */}
                            <td className="text-end text-level-3">
                              {(() => {
                                const attrTotal = item?.attributes?.reduce(
                                  (sum, a) => sum + (Number(a.value) || 0),
                                  0,
                                );
                                const childrenTotal = item?.children?.reduce(
                                  (sum, c) =>
                                    sum + (Number(c.productPrice) || 0),
                                  0,
                                );
                                const basePrice =
                                  Number(item?.productPrice) || 0;
                                const qty = Number(item?.quantity) || 0;

                                const unitPrice =
                                  attrTotal || childrenTotal
                                    ? basePrice + attrTotal + childrenTotal
                                    : basePrice;

                                return (unitPrice * qty).toFixed(2);
                              })()}
                            </td>
                          </tr>

                          {/* Complimentary Row Inserted Here */}
                          {ComplimentaryRow}
                        </React.Fragment>
                      );
                    })}
                  </tbody>
                </Table>

                {/* ===== Totals ===== */}
                <div className="border-top pt-2 small">
                  <div className="d-flex justify-content-between">
                    <div>Total Qty:</div>
                    <div>{totalQty}</div>
                  </div>
                  <div className="d-flex justify-content-between">
                    <div>Sub Total:</div>
                    <div>Rs. {responseData?.totalAmount?.toFixed(2)}</div>
                  </div>
                  <div className="d-flex justify-content-between">
                    <div>Discount Amount:</div>
                    <div>Rs. {responseData?.discountAmount?.toFixed(2)}</div>
                  </div>
                  {responseData?.taxAmount > 0 && (
                    <div className="d-flex justify-content-between">
                      <div>Tax Amount:</div>
                      <div>Rs. {responseData?.taxAmount?.toFixed(2)}</div>
                    </div>
                  )}
                  <div className="d-flex justify-content-between fw-bold">
                    <div>Grand Total:</div>
                    <div>Rs. {responseData?.grandTotal?.toFixed(2)}</div>
                  </div>
                  <div className="mt-2">
                    <strong>In Words:</strong>{" "}
                    {numberToWords(responseData?.grandTotal)}
                  </div>
                </div>

                {/* ===== Footer ===== */}
                <div className="small mt-2">
                  <div>Printed On: {new Date().toLocaleString()}</div>
                  <div className="text-center mt-2">**Thank You**</div>
                  <div className="text-center text-muted small">
                    Powered by Restro Order
                  </div>
                </div>
              </CardBody>
            </Card>
          </div>
        </ModalBody>
      </Modal>

      {/* ===== Payment QR Modal ===== */}
      <Modal
        isOpen={paymentModalOpen}
        toggle={() => setPaymentModalOpen(false)}
        centered
        size="md"
      >
        <ModalHeader toggle={() => setPaymentModalOpen(false)}>
          Payment Details
        </ModalHeader>
        <ModalBody className="text-center">
          {activePayment && (
            <img
              src={`${qrImageBase}/${activePayment?.imagePath}`}
              alt={activePayment.name}
              className="img-fluid object-fit-contain"
            />
          )}
        </ModalBody>
      </Modal>
    </>
  );
};

export default InvoiceBillModal;
